import { useState } from 'react';
import { useCustom } from '@refinedev/core';
import { Card, Segmented, Typography } from 'antd';
import { Line } from '@ant-design/charts';
import type { MonetizationSystemHealthOut } from '@/api/generated/schemas';

const WINDOWS = [
  { label: '24h', value: 24 },
  { label: '48h', value: 48 },
  { label: '7 dni', value: 168 },
];

export const MonetizationSystemHealthCard = () => {
  const [hours, setHours] = useState(24);

  const { query } = useCustom<MonetizationSystemHealthOut>({
    url: 'monetization/revenuecat_events/stats/system_health',
    method: 'get',
    config: { query: { hours } },
    queryOptions: { refetchInterval: 60_000 },
  });

  const data = query.data?.data?.ingestion_rate ?? [];

  return (
    <Card
      title="Zdrowie systemu"
      extra={
        <Segmented
          options={WINDOWS.map((w) => ({ label: w.label, value: w.value }))}
          value={hours}
          onChange={(v) => setHours(v as number)}
        />
      }
      loading={query.isLoading}
    >
      {data.length > 0 ? (
        <Line
          data={data}
          xField="hour"
          yField="event_count"
          height={200}
          axis={{
            x: { labelFormatter: (v: string) => v.slice(11, 16) },
          }}
        />
      ) : (
        <Typography.Text type="secondary">Brak danych</Typography.Text>
      )}
    </Card>
  );
};
